const COOKIE_NAME = "access_token";
const SESSION_HINT_KEY = "auth_session_hint";

export const markAuthClientSession = (): void => {
  try {
    localStorage.setItem(SESSION_HINT_KEY, "1");
  } catch (_error) {
    // noop
  }
};

export const hasAuthClientSession = (): boolean => {
  try {
    return localStorage.getItem(SESSION_HINT_KEY) === "1";
  } catch (_error) {
    return false;
  }
};

export const clearAuthTokenCookie = (): void => {
  document.cookie = `${COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Lax`;
};

export const clearAuthClientSession = (): void => {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem(SESSION_HINT_KEY);
  } catch (_error) {
    // noop
  }
  clearAuthTokenCookie();
};
